<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row class="justify-center">
            <v-col
              cols="12"
              lg="12"
            >
              <v-form ref="form_all">
                <v-tabs
                  align-with-title
                  show-arrows
                >
                  <v-tab>
                    <v-icon left>
                      mdi-receipt
                    </v-icon>Основное
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-cash-register
                    </v-icon>Оборудование
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-lan-pending
                    </v-icon>Параметры подключения
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-account-multiple-outline
                    </v-icon>Пользователи
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-credit-card-settings-outline
                    </v-icon>Способы оплаты
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-check-decagram-outline
                    </v-icon>Идентификация MAX
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-account-multiple-outline
                    </v-icon>Мониторинг
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-wifi-settings
                    </v-icon>Настройки связи
                  </v-tab>
                  <v-tab v-if="form.qr_sticker.enable">
                    <v-icon left>
                      mdi-qrcode
                    </v-icon>QR код для оплаты заказов
                  </v-tab>
                  <v-tab v-if="form.qr_paymentsystem.enable">
                    <v-icon left>
                      mdi-qrcode-scan
                    </v-icon>QR код для пожертвований и витрин
                  </v-tab>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        lg="4"
                        xl="2"
                      >
                        <v-text-field
                          v-model="form.created"
                          label="Дата создания"
                          type="date"
                          :disabled="true"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        lg="4"
                        xl="2"
                      >
                        <v-text-field
                          v-model="form.number"
                          label="Системный номер"
                          :disabled="true"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        lg="4"
                        xl="2"
                      >
                        <v-select
                          v-model="form.state"
                          label="Статус"
                          :items="select.state"
                          :disabled="create || view"
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="form.external_id"
                          label="Внешний идентификатор"
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-tooltip
                          bottom
                          max-width="25%"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="form.timezone"
                              type="number"
                              label="Часовой пояс точки"
                              v-bind="attrs"
                              v-on="on"
                              @change="onChangeTimezone"
                              @click="onChangeTimezone"
                            />
                          </template>
                          <span>Часовой пояс принимает значение стандарта UTC. Данное поле влияет на время в кассовом чеке. Например для терминала находящегося в г.Москва значение должно быть 3</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="6">
                        <v-select
                          v-model="form.email_type"
                          label="Отправка чека на почту"
                          :items="[
                            {
                              value: 0,
                              text: 'Не отправлять'
                            },
                            {
                              value: 1,
                              text: 'Отправлять на почту из атрибутов платежа'
                            },
                            {
                              value: 2,
                              text: 'Задать почту'
                            }
                          ]"
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-if="form.email_type === 2"
                          v-model="form.email_value"
                          type="text"
                          label="E-mail"
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-select
                          v-model="form.tgbot"
                          label="Отправка чека в Telegram бот"
                          :items="[
                            {
                              value: 0,
                              text: 'Не отправлять'
                            },
                            {
                              value: 1,
                              text: 'Отправлять'
                            },

                          ]"
                        />
                      </v-col>
                      <v-col cols="6" />
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="4"
                      >
                        <v-select
                          v-model="form.local_fiscal.enable"
                          label="Фискализация"
                          :items="[
                            {
                              value: false,
                              text: 'Серверная (Justpay)'
                            },
                            {
                              value: true,
                              text: 'Локальная'
                            }
                          ]"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="4"
                      >
                        <v-text-field
                          v-if="form.local_fiscal.enable"
                          v-model="form.local_fiscal.ipAddress"

                          type="text"
                          label="IP адрес"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="4"
                      >
                        <v-text-field
                          v-if="form.local_fiscal.enable"
                          v-model="form.local_fiscal.port"
                          type="text"
                          label="порт"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col cols="12">
                        <v-autocomplete
                          v-if="$store.state.access[15][5]"
                          v-model="form.client"
                          clearable
                          :filter="client_filter"
                          :items="select.clients"
                          item-value="id"
                          label="Наименование клиента"
                          :disabled="view"
                          :loading="search.client.loading"
                          :search-input.sync="search.client.text"
                          hide-no-data
                          hint="Введите минимум три символа для поиска"
                          @change="client_selected"
                        >
                          <template v-slot:selection="{item}">
                            <v-list>
                              <v-list-item-content>
                                <v-list-item-title> {{ item.legal.name.short || item.legal.name.full }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list>
                          </template>
                          <template v-slot:item="{item}">
                            <v-list two-line>
                              <v-list-item-content>
                                <v-list-item-title>  {{ item.legal.name.short || item.legal.name.full }}</v-list-item-title>
                                <v-list-item-subtitle>ИНН: {{ item.legal.inn }} КПП: {{ item.legal.kpp }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row class="d-flex justify-center">
                      <v-col
                        class="d-flex justify-end align-center"
                        cols="12"
                        sm="1"
                        offset-xl="2"
                      >
                        <v-btn
                          icon
                          @click="onOpenConfiguration"
                        >
                          <v-icon color="#315bbf">
                            mdi-open-in-new
                          </v-icon>
                        </v-btn>
                      </v-col>

                      <v-col
                        class="d-flex justify-center"
                        cols="12"
                        sm="11"
                        xl="6"
                      >
                        <v-select
                          v-model="form.configuration"
                          label="Конфигурация"
                          :items="select.configurations"
                          item-text="name"
                          item-value="id"
                        />
                      </v-col>
                      <v-col xl="3" />
                    </v-row>
                    <v-row class="justify-end justify-xl-center">
                      <v-col
                        cols="12"
                        sm="11"
                        xl="6"
                      >
                        <v-text-field
                          v-model="form.name"
                          label="Наименование точки"
                          :disabled="view"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col
                        class="d-flex justify-end align-center"
                        cols="12"
                        sm="1"
                        offset-xl="2"
                      >
                        <v-btn
                          icon
                          @click="onOpenPlace"
                        >
                          <v-icon color="#315bbf">
                            mdi-open-in-new
                          </v-icon>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="11"
                        xl="6"
                      >
                        <v-select
                          v-model="form.place"
                          label="Место установки"
                          :items="select.place"
                          item-value="id"
                          item-text="name_full"
                        />
                      </v-col>
                      <v-col xl="3" />
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        offset-sm="1"
                        offset-xl="3"
                      >
                        <v-switch
                          v-model="form.kiosk_mode"
                          :label="form.kiosk_mode ? 'Режим киоска включен' : 'Режим киоска выключен'"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        lg="4"
                        xl="2"
                      >
                        <v-select
                          v-model="selected.type"
                          :items="select.type"
                          label="Тип устройства"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        lg="4"
                        xl="2"
                      >
                        <v-autocomplete
                          v-model="selected.equipment"
                          :filter="equipment_filter"
                          return-object
                          :items="select.equipment.filter(a=>!selected.type || a.type == selected.type)"
                          label="Поиск оборудования"
                          :disabled="view || !form.client"
                          :loading="search.equipment.loading"
                          :search-input.sync="search.equipment.text"
                          hide-no-data
                          hint="Введите минимум три символа для поиска"
                        >
                          <template v-slot:selection="{item}">
                            <v-list>
                              <v-list-item-content>
                                <span v-if="item && item.device">
                                  <font color="#315bbf">{{ dict.type[item.type] }} {{ dict.device[item.device] }}</font>
                                </span>
                                <br>
                                <span v-if="item">
                                  {{ item.serial }}
                                </span>
                              </v-list-item-content>
                            </v-list>
                          </template>
                          <template v-slot:item="{item}">
                            <v-list two-line>
                              <v-list-item-content>
                                <span v-if="item && item.device">
                                  <font color="#315bbf">{{ dict.type[item.type] }} {{ dict.device[item.device] }}</font>
                                </span>
                                <br>
                                <span v-if="item">
                                  {{ item.serial }}
                                </span>
                              </v-list-item-content>
                            </v-list>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="4"
                        xl="2"
                      >
                        <v-btn
                          color="primary"
                          :disabled="!selected.equipment"
                          @click="onCheckEquipment(selected.equipment)"
                        >
                          <span class="mx-10">Добавить</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        lg="12"
                        xl="6"
                      >
                        <v-data-table
                          :items="form.equipments"
                          :headers="[
                            {
                              text: 'Номер',
                              value: 'number',
                            },
                            {
                              text: 'Тип',
                              value: 'type',
                            },
                            {
                              text: 'Модель',
                              value: 'model',
                            },
                            {
                              text: 'Серийный номер',
                              value: 'serial',
                            },
                            {
                              text: 'Действие',
                              value: 'delete'
                            }
                          ]"
                          :footer-props="datatable_footer"
                          no-data-text="Нет данных для отображения"
                          @click:row="(a) => {selected.current_equipment = a, selected.change_settings = false}"
                        >
                          <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                            {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                          </template>
                          <template v-slot:item.model="{ item }">
                            <span v-if="item && item.device">
                              {{ dict.device[item.device] }}
                            </span>
                          </template>
                          <template v-slot:item.type="{ item }">
                            <span v-if="item && item.type">
                              {{ dict.type[item.type] }}
                            </span>
                          </template>
                          <template v-slot:item.delete="{ item }">
                            <v-icon @click="change_equipment(item)">
                              mdi-pencil
                            </v-icon>
                            <v-icon @click="delete_equipment(item)">
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>

                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        lg="12"
                        xl="6"
                      >
                        <v-data-table
                          v-if="selected.current_equipment"
                          :items="select.device.filter(a=>a.id == selected.current_equipment.device)[0].settings"
                          :headers="[
                            {value: 'description', text: 'Описание', width: 300},
                            {value: 'value', text: 'Значение', width: 150},
                          ]"
                          no-data-text="Нет данных для отображения"
                        >
                          <template v-slot:item.description="{item}">
                            <v-text-field
                              v-model="item.description"
                              readonly
                              @input="settings_change(selected.current_equipment,item)"
                            />
                          </template>

                          <template v-slot:item.value="{item}">
                            <v-text-field
                              v-if="item.type == 0"
                              v-model="selected.current_equipment.settings[item.key]"
                              :disabled="!selected.change_settings"
                              @input="settings_change(selected.current_equipment,item)"
                            />
                            <v-checkbox
                              v-if="item.type == 1"
                              v-model="selected.current_equipment.settings[item.key]"
                              :disabled="!selected.change_settings"
                              @change="settings_change(selected.current_equipment,item)"
                            />
                            <v-select
                              v-if="item.type == 2"
                              v-model="selected.current_equipment.settings[item.key]"
                              :items="item.values"
                              :disabled="!selected.change_settings"
                              @change="settings_change(selected.current_equipment,item)"
                            />
                            <v-textarea
                              v-if="item.type == 3"
                              v-model="selected.current_equipment.settings[item.key]"
                              :disabled="!selected.change_settings"
                              @change="settings_change(selected.current_equipment,item)"
                            />
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        lg="12"
                        xl="6"
                      >
                        <v-autocomplete
                          v-model="token.equipment"
                          :filter="equipment_filter"
                          item-value="id"
                          :items="form.equipments"
                          label="Поиск оборудования"
                          :disabled="view || !form.client"
                          :loading="search.equipment.loading"
                          :search-input.sync="search.equipment.text"
                          hide-no-data
                          hint="Введите минимум три символа для поиска"
                          @change="equipment_selected"
                        >
                          <template v-slot:selection="{item}">
                            <v-list>
                              <v-list-item-content>
                                <span v-if="item && item.device">
                                  <font color="#315bbf">{{ dict.type[item.type] }} {{ dict.device[item.device] }}</font>
                                </span>
                                <br>
                                <span v-if="item">
                                  {{ item.serial }}
                                </span>
                              </v-list-item-content>
                            </v-list>
                          </template>
                          <template v-slot:item="{item}">
                            <v-list two-line>
                              <v-list-item-content>
                                <span v-if="item && item.device">
                                  <font color="#315bbf">{{ dict.type[item.type] }} {{ dict.device[item.device] }}</font>
                                </span>
                                <br>
                                <span v-if="item">
                                  {{ item.serial }}
                                </span>
                              </v-list-item-content>
                            </v-list>
                          </template>
                        </v-autocomplete>
                        <v-text-field
                          v-model="token.serial"
                          label="Серийный номер"
                        />
                        <v-btn
                          color="primary"
                          @click="generate_token"
                        >
                          <span class="mx-10">Генерация токена</span>
                        </v-btn>
                        <v-textarea
                          v-model="form.token"
                          label="Токен"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        lg="12"
                        xl="6"
                      >
                        <v-text-field
                          v-model="pair_code"
                          label="Pin-токена"
                          append-icon="mdi-update"
                          @click:append="pair"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        lg="12"
                        xl="6"
                      >
                        <v-data-table
                          disable-sort
                          :items="form.users"
                          :headers="[{
                                       value: 'name',
                                       text: 'ФИО'
                                     },
                                     {
                                       value: 'phone',
                                       name: 'Телефон'
                                     },
                                     {
                                       value: 'action',
                                       text: 'Действия'
                                     }]"
                          :footer-props="datatable_footer"
                          no-data-text="Нет данных для отображения"
                        >
                          <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                            {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                          </template>
                          <template v-slot:item.name="{item}">
                            {{ item.surname }} {{ item.name }} {{ item.patronymic }}
                          </template>
                          <template v-slot:item.action="{item}">
                            <v-icon
                              large
                              @click="delete_user(item)"
                            >
                              mdi-minus-circle-outline
                            </v-icon>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        class="text-center"
                        lg="12"
                        xl="6"
                      >
                        <v-btn
                          text
                          color="primary"
                          @click="show_add_user_dialog()"
                        >
                          <v-icon
                            large
                            class="mr-2"
                            color="primary"
                          >
                            mdi-plus-circle-outline
                          </v-icon>
                          Добавить пользователя
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-checkbox
                          v-model="form.bank_card.enable"
                          label="Оплата банковской картой"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.bank_card.enable">
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-select
                          v-model="form.bank_card.bank"
                          label="Вид банковского ПО"
                          :items="[{value: 0, text: 'Эмулятор'}, {value: 1, text: 'Сбербанк'},{value: 2, text: 'SkyPos'},{value: 3, text: 'Dataphone'}, {value: 4, text: 'Uniteller'}, {value: 5, text: 'Сбербанк UPOS3'}, {value: 6, text: '2can'}, {value: 7, text: 'Joinpos'}, {value: 8, text: 'Lanter'}, {value: 9, text: 'PayPro'}, {value: 10, text: 'Inpas'}, {value: 11, text: 'MSB'}]"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.bank_card.enable && form.bank_card.bank !=4">
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="form.bank_card.sverka_time"
                          label="Время сверки итогов"
                          type="time"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.bank_card.enable && (form.bank_card.bank ===5 || form.bank_card.bank ===6)">
                      <v-col cols="6">
                        <v-text-field
                          v-model="form.bank_card.billing_ip"
                          label="IP-адрес биллинга "
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="form.bank_card.billing_port"
                          type="number"
                          label="Порт биллинга"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.bank_card.enable && form.bank_card.bank == 4">
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="form.bank_card.port"
                          label="Порт"
                        />
                        <v-text-field
                          v-model="form.bank_card.tid"
                          label="TID"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.bank_card.enable && form.bank_card.bank == 9">
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="form.bank_card.paypro.login"
                          label="Логин"
                        />
                        <v-text-field
                          v-model="form.bank_card.paypro.password"
                          label="Пароль"
                        />
                        <v-select
                          v-model="form.bank_card.paypro.view"
                          :items="[{text: 'Отображать PayPro',value:1},{text: 'Отображать Justpay',value:2}]"
                          label="Интерфейс"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.bank_card.enable && form.bank_card.bank == 11">
                      <v-col>
                        <v-select
                            v-model="form.bank_card.msb.connection"
                            label="Способ подключения"
                            :items="[{text:'RS232',value:1},{text:'USB', value:2},{text:'Bluetooth',value:3}]"
                        />
                      </v-col>
                      <v-col>
                        <v-text-field
                            v-model="form.bank_card.msb.department"
                            type="number"
                        >
                          Отдел
                        </v-text-field>
                      </v-col>
                      <v-col>
                        <v-select
                            v-model="form.bank_card.msb.baudRate"
                            label="Baud rate"
                            :items="[{text:'0',value:0},{text:'9600',value:1},{text:'11500',value:2}]"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-checkbox
                          v-model="form.bank_card.sverka_enabled"
                          label="Включить сверку"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-checkbox
                          v-model="form.sbp.enable"
                          label="Включить СБП"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.sbp.enable">
                      <v-col
                        cols="12"
                        class="text-center"
                        md="12"
                      >
                        <v-select
                          v-model="form.sbp.sbpprofile"
                          label="Профиль СБП"
                          :disabled="view"
                          item-text="description"
                          item-value="id"
                          :items="select.sbpprofile"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-checkbox
                          v-model="form.cash.enable"
                          label="Включить наличные"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.cash.enable">
                      <v-col
                        cols="12"
                        class="text-center"
                        md="12"
                      />
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-checkbox
                          v-model="form.digital_ruble.enable"
                          label="Включить цифровой рубль"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.digital_ruble.enable">
                      <v-col
                        cols="12"
                        class="text-center"
                        md="12"
                      >
                        <v-text-field
                          v-model="form.digital_ruble.url"
                          label="URL"
                        />
                        <v-text-field
                          v-model="form.digital_ruble.timeout"
                          type="number"
                          label="Таймаут запроса (секунды)"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-checkbox
                          v-model="form.qr_sticker.enable"
                          label="Включить QR стикер для оплаты заказов"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.qr_sticker.enable">
                      <v-col
                        cols="12"
                        class="text-center"
                        md="12"
                      >
                        <v-select
                          v-model="form.qr_sticker.sbpprofile"
                          label="Профиль СБП"
                          :disabled="view"
                          item-text="description"
                          item-value="id"
                          :items="select.sbpprofile"
                        />
                      </v-col>
                    </v-row>
                    <!-- payment system -->
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-checkbox
                          v-model="form.qr_paymentsystem.enable"
                          label="Включить QR стикер для пожертвований, витрин и POS точки с реле"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.qr_paymentsystem.enable">
                      <v-col
                        cols="12"
                        class="text-center"
                        md="6"
                      >
                        <v-select
                          v-model="form.qr_paymentsystem.sbpprofile"
                          label="Профиль СБП"
                          :disabled="view"
                          item-text="description"
                          item-value="id"
                          :items="select.sbpprofile"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <!--                        <v-checkbox-->
                        <!--                          v-model="form.qr_paymentsystem.isRelay"-->
                        <!--                          label="Использование реле"-->
                        <!--                        />-->
                        <v-select
                          v-model="form.qr_paymentsystem.qrStickerRelayType"
                          label="Использование реле"
                          :items="[{text:'Без реле', value:0},{text:'С реле', value:1},{text:'POS-точка с реле', value:2}]"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-checkbox
                          v-model="form.access_by_staff_card"
                          label="Доступ по карте сотрудника"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="form.access_by_staff_card">
                      <v-col
                        cols="12"
                        sm="4"
                      >
                        <v-select
                          v-model="form.accessByCardStuff.identityType"
                          label="Тип идентификатора"
                          :items="[{text:'Mifare ID', value:1}, {text: 'Номер карты', value:2}]"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="4"
                      >
                        <v-text-field
                          v-model="form.accessByCardStuff.ipAddress"
                          label="Сервер авторизации - IP адрес сервера"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="4"
                      >
                        <v-text-field
                          v-model="form.accessByCardStuff.port"
                          type="number"
                          label="Сервер авторизации - Порт сервера"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                      >
                        <v-select
                          v-model="form.verification.verificationRequirement"
                          :items="[{text:'Нет',value:0},{text:'Если есть товар 18+',value:1},{text:'Для всех платежей',value:2}]"
                          label="Запрашивать идентификацию MAX"
                        />
                      </v-col>
                      <v-col
                        v-if="form.verification.verificationRequirement!==0"
                        cols="12"
                      >
                        <v-select
                          v-model="form.verification.profileId"
                          label="Профиль Идентификации MAX"
                          :items="select.profiles"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row>
                      <v-col cols="12">
                        Текущий статус
                      </v-col>
                      <!--                      <v-col cols="12">-->
                      <!--                        <v-text-field-->
                      <!--                          v-model="monitoring_date"-->
                      <!--                          type="date"-->
                      <!--                          label="Дата"-->
                      <!--                          @change="load(form.id)"-->
                      <!--                        />-->
                      <!--                      </v-col>-->
                      <v-col cols="6">
                        <v-text-field
                          :value="format_time(point!==null ? point.date : new Date())"
                          label="Дата/время точки"
                          readonly
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          :value="format_time(point!==null ? point.configurationUpdated: new Date())"
                          label="Дата/время конфигурации"
                          readonly
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="point.model"
                          label="Модель"
                          readonly
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="point.submodel"
                          label="Подмодель"
                          readonly
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="point.batteryPercent"
                          label="Процент батареи"
                          readonly
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          :value="format_time(point!==null?point.lastSale:new Date())"
                          label="Дата/время последней продажи"
                          readonly
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="point.terminalId"
                          label="ID терминала"
                          readonly
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="point.libraryVersion"
                          label="Версия библиотеки"
                          readonly
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        История
                      </v-col>
                      <!-- commented begin -->
                      <v-col
                        cols="1"
                        class="d-flex justify-center align-center"
                      >
                        С
                      </v-col>
                      <v-col cols="3">
                        <v-menu
                          v-model="monitoring.menu.from"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          min-width="auto"
                          offset-y
                          transition="scale-transition"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="format(monitoring.date.from)"
                              append-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            v-model="monitoring.date.from"
                            first-day-of-week="1"
                            locale="ru-RU"
                            @input="monitoring.menu.from = false"
                          />
                        </v-menu>
                      </v-col>
                      <v-col
                        cols="1"
                        class="d-flex justify-center align-center"
                      >
                        по
                      </v-col>
                      <v-col cols="3">
                        <v-menu
                          v-model="monitoring.menu.to"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          min-width="auto"
                          offset-y
                          transition="scale-transition"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="format(monitoring.date.to)"
                              append-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            v-model="monitoring.date.to"
                            first-day-of-week="1"
                            locale="ru-RU"
                            @input="monitoring.menu.to = false"
                          />
                        </v-menu>
                      </v-col>
                      <v-col
                        cols="4"
                        class="d-flex justify-center align-center"
                      >
                        <v-btn
                          color="primary"
                          outlined
                          @click="onMonitoring"
                        >
                          Выбрать
                        </v-btn>
                      </v-col>
                      <!-- commented end -->
                      <v-col cols="12">
                        <v-data-table
                          :items="monitoring.items"
                          :options.sync="monitoring_table_options"
                          :server-items-length="monitoring.total"
                          :headers="[
                            {
                              value:'date',
                              text:'Дата/время'
                            },
                            {
                              value:'batteryPercent',
                              text: 'Процент батареи'
                            },
                            {
                              value: 'lastSale',
                              text: 'Последняя продажа'
                            }
                          ]"
                        >
                          <template v-slot:item.date="{item}">
                            {{ format_time(item.date) }}
                          </template>
                          <!-- commented begin -->
                          <template v-slot:item.lastSale="{item}">
                            {{ format_time(item.lastSale) }}
                          </template>
                          <!-- commented end -->
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        MDB логи
                      </v-col>
                      <!-- commented begin -->
                      <v-col
                        cols="1"
                        class="d-flex justify-center align-center"
                      >
                        С
                      </v-col>
                      <v-col cols="3">
                        <v-menu
                          v-model="mdb.menu.from"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          min-width="auto"
                          offset-y
                          transition="scale-transition"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="format(mdb.date.from)"
                              append-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            v-model="mdb.date.from"
                            first-day-of-week="1"
                            locale="ru-RU"
                            @input="mdb.menu.from = false"
                          />
                        </v-menu>
                      </v-col>
                      <v-col
                        cols="1"
                        class="d-flex justify-center align-center"
                      >
                        по
                      </v-col>
                      <v-col cols="3">
                        <v-menu
                          v-model="mdb.menu.to"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          min-width="auto"
                          offset-y
                          transition="scale-transition"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="format(mdb.date.to)"
                              append-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            v-model="mdb.date.to"
                            first-day-of-week="1"
                            locale="ru-RU"
                            @input="mdb.menu.to = false"
                          />
                        </v-menu>
                      </v-col>
                      <v-col
                        cols="4"
                        class="d-flex justify-center align-center"
                      >
                        <v-btn
                          color="primary"
                          outlined
                          @click="onMdbLog"
                        >
                          Выбрать
                        </v-btn>
                      </v-col>
                      <!-- commented end -->
                      <v-col cols="12">
                        <v-data-table
                          :items="mdb.items"
                          :options.sync="mdb_table_options"
                          :server-items-length="mdb.total"
                          :headers="[
                            {
                              value:'date',
                              text:'Дата/время'
                            },
                            {
                              value:'direction',
                              text:'Направление'
                            },
                            {
                              value:'command',
                              text: 'Команда'
                            },
                          ]"
                        >
                          <template v-slot:item.date="{item}">
                            {{ format_time(item.date) }}
                          </template>
                          <template v-slot:item.direction="{item}">
                            <span v-if="item.direction == 1">Отправлено</span>
                            <span v-if="item.direction == 0">Получено</span>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        ADB логи
                      </v-col>
                      <!--                      commented begin-->
                      <v-col
                        cols="1"
                        class="d-flex justify-center align-center"
                      >
                        С
                      </v-col>
                      <v-col cols="3">
                        <v-menu
                          v-model="adb.menu.from"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          min-width="auto"
                          offset-y
                          transition="scale-transition"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="format(adb.date.from)"
                              append-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            v-model="adb.date.from"
                            first-day-of-week="1"
                            locale="ru-RU"
                            @input="adb.menu.from = false"
                          />
                        </v-menu>
                      </v-col>
                      <v-col
                        cols="1"
                        class="d-flex justify-center align-center"
                      >
                        по
                      </v-col>
                      <v-col cols="3">
                        <v-menu
                          v-model="adb.menu.to"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          min-width="auto"
                          offset-y
                          transition="scale-transition"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="format(adb.date.to)"
                              append-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            v-model="adb.date.to"
                            first-day-of-week="1"
                            locale="ru-RU"
                            @input="adb.menu.to = false"
                          />
                        </v-menu>
                      </v-col>
                      <v-col
                        cols="4"
                        class="d-flex justify-center align-center"
                      >
                        <v-btn
                          color="primary"
                          outlined
                          @click="onAdbLog"
                        >
                          Выбрать
                        </v-btn>
                      </v-col>
                      <!-- commented end-->
                      <v-col cols="12">
                        <v-data-table
                          :items="adb.items"
                          :options.sync="adb_table_options"
                          :server-items-length="adb.total"
                          :headers="[
                            {
                              value:'date',
                              text:'Дата/время'
                            },
                            {
                              value:'tag',
                              text:'TAG'
                            },
                            {
                              value:'message',
                              text: 'Сообщение'
                            },
                          ]"
                        >
                          <template v-slot:item.date="{item}">
                            {{ format_time(item.date) }}
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row justify="center">
                      <v-col cols="12">
                        <v-expansion-panels>
                          <v-expansion-panel>
                            <v-expansion-panel-header class="text-h4">
                              <v-row>
                                <v-col>
                                  Wifi - точка доступа
                                </v-col>
                              </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="6"
                                  offset-md="3"
                                >
                                  <v-switch
                                    v-model="form.wifi_hotspot.is_active"
                                    :label="form.wifi_hotspot.is_active ? 'Включено' : 'Выключено'"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="6"
                                  offset-md="3"
                                >
                                  <v-text-field
                                    v-model="form.wifi_hotspot.network_name"
                                    label="Название сети"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="6"
                                  offset-md="3"
                                >
                                  <v-text-field
                                    v-model="form.wifi_hotspot.password"
                                    label="Пароль точки доступа"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="6"
                                  offset-md="3"
                                >
                                  <v-select
                                    v-model="form.wifi_hotspot.security_key"
                                    label="Тип шифрования"
                                    :items="[{text:'None',value:'None'},{text:'WPA2_PSK',value:'WPA2_PSK'}]"
                                  />
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header class="text-h4">
                              <v-row>
                                <v-col>
                                  Wifi - сеть
                                </v-col>
                              </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-row>
                                <v-col>
                                  <v-switch
                                    v-model="form.wifi_net.is_active"
                                    :label="form.wifi_net.is_active ? 'Включено' : 'Выключено'"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="6"
                                >
                                  <v-text-field
                                    v-model="form.wifi_net.network_name"
                                    label="Название сети"
                                  />
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="6"
                                >
                                  <v-text-field
                                    v-model="form.wifi_net.password"
                                    label="Пароль точки доступа"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="6"
                                >
                                  <v-select
                                    v-model="form.wifi_net.security_key"
                                    label="Тип шифрования"
                                    :items="[{text:'None',value:'None'},{text:'WPA2_PSK',value:'WPA2_PSK'}]"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="6"
                                >
                                  <v-select
                                    v-model="form.wifi_net.addressing_mode"
                                    :items="select.addressing_mode"
                                    label="Режим адресации"
                                  />
                                </v-col>
                              </v-row>
                              <v-row v-if="form.wifi_net.addressing_mode===1">
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="form.wifi_net.ip_address"
                                    label="IP адрес терминала"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="form.wifi_net.mask"
                                    label="Маска сети"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="form.wifi_net.gateway"
                                    label="IP адрес шлюза"
                                  />
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header class="text-h4">
                              <v-row>
                                <v-col>
                                  Ethernet - сеть
                                </v-col>
                              </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-row>
                                <v-col>
                                  <v-switch
                                    v-model="form.ethernet.is_active"
                                    :label="form.ethernet.is_active ? 'Включено' : 'Выключено'"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="6"
                                >
                                  <v-select
                                    v-model="form.ethernet.addressing_mode"
                                    :items="select.addressing_mode"
                                    label="Режим адресации"
                                  />
                                </v-col>
                              </v-row>
                              <v-row v-if="form.ethernet.addressing_mode===1">
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="form.ethernet.ip_address"
                                    label="IP адрес терминала"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="form.ethernet.mask"
                                    label="Маска сети"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="form.ethernet.gateway"
                                    label="IP адрес шлюза"
                                  />
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header class="text-h4">
                              <v-row>
                                <v-col>
                                  Мобильная сеть 3G/4G
                                </v-col>
                              </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-row>
                                <v-col>
                                  <v-switch
                                    v-model="form.cellular_net.is_active"
                                    :label="form.cellular_net.is_active ? 'Включено' : 'Выключено'"
                                  />
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="6"
                                >
                                  <v-select
                                    v-model="form.cellular_net.cellular_generation"
                                    :items="select.cellular_generation"
                                    label="Режим работы сети"
                                  />
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item v-if="form.qr_sticker.enable">
                    <v-row justify="center">
                      <v-col
                        cols="12"
                      >
                        <v-card>
                          <v-card-text>
                            <v-row>
                              <v-col
                                cols="10"
                                sm="9"
                              >
                                <div v-if="qrImage">
                                  <span>Ссылка для регистрации точки обслуживания:  </span> <a
                                    :href="this.qrImage.url"
                                    target="_blank"
                                  ><span style="color: darkblue">{{ this.qrImage.url }}</span> </a>
                                </div>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                cols="12"
                                md="6"
                              >
                                <v-img
                                  v-if="qrImage"
                                  :src="'data:image/jpg;base64,'+this.qrImage.image"
                                />
                              </v-col>
                            </v-row>
                            <v-row v-if="qrImage">
                              <v-col>
                                <v-btn
                                  color="info"
                                  outlined
                                  @click="onDownloadImage"
                                >
                                  <v-icon>mdi-download</v-icon>
                                  Скачать
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item v-if="form.qr_paymentsystem.enable">
                    <v-row justify="center">
                      <v-col
                        cols="12"
                      >
                        <v-card>
                          <v-card-text>
                            <v-row>
                              <v-col
                                cols="10"
                                sm="9"
                              >
                                <div v-if="qrPaymentSystemImage">
                                  <span>Ссылка для регистрации точки обслуживания:  </span> <a
                                    :href="this.qrPaymentSystemImage.url"
                                    target="_blank"
                                  ><span style="color: darkblue">{{ this.qrPaymentSystemImage.url }}</span> </a>
                                </div>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                cols="12"
                                md="6"
                              >
                                <v-img
                                  v-if="qrPaymentSystemImage"
                                  :src="'data:image/jpg;base64,'+this.qrPaymentSystemImage.image"
                                />
                              </v-col>
                            </v-row>
                            <v-row v-if="qrPaymentSystemImage">
                              <v-col>
                                <v-btn
                                  color="info"
                                  outlined
                                  @click="onDownloadImage"
                                >
                                  <v-icon>mdi-download</v-icon>
                                  Скачать
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row class="justify-center">
            <v-col
              cols="4"
              lg="2"
            >
              <v-btn
                color="primary"
                outlined
                @click="$router.go(-1)"
              >
                <span class="mx-3">Назад</span>
              </v-btn>
            </v-col>
            <v-col
              cols="4"
              lg="2"
              class="text-center"
            >
              <v-btn
                v-if="!view"
                color="primary"
                class="ml-auto"
                @click="save_point(true)"
              >
                <span class="mx-3">Сохранить</span>
              </v-btn>
            </v-col>
            <v-col
              cols="4"
              lg="2"
              class="text-right"
            >
              <v-btn
                v-if="!view"
                color="blue darken-1 white--text"
                class="ml-auto"
                @click="save_point(false)"
              >
                <span class="mx-3">Применить</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-dialog
      v-model="dialog.user.show"
      max-width="50%"
    >
      <v-card class="ma-n1">
        <v-card-title>Выберите пользователей</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="dialog.user.selected"
                clearable
                :items="select.user"

                label="Выберите пользователей"
                hide-no-data
                multiple
                outlined
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row class="mx-1">
            <v-col
              cols="6"
              lg="6"
            >
              <v-btn
                color="primary"
                outlined
                @click="dialog.user.show = false"
              >
                <span class="mx-3">Отмена</span>
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              lg="6"
              class="text-right"
            >
              <v-btn
                color="primary"
                @click="add_users()"
              >
                <span class="mx-3">Добавить</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-yes-no
      v-if="dialogVisible"
      title="Предупреждение"
      :text="dialogNoYes.text"
      @no="dialogVisible=false"
      @yes="dialogNoYes.actionYes"
    />
  </v-row>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  import suggest from '../../../libs/suggestions.min.17.12.0.dev.js'
  import { diff, addedDiff, deletedDiff, updatedDiff, detailedDiff } from 'deep-object-diff'
  import EventForm from './../EventForm'
  import { MonitoringPaginationService } from "@/views/monitoring/shared/services/monitoring-pagination-service"
  import { format } from "date-fns-tz"
  import { MonitoringService } from "@/views/monitoring/shared/services/monitoring-service"
  import { JustpayPointService } from "@/views/loyalty/shared/services/justpay-point-service"
  import DialogYesNo from "@/views/loyalty/shared/components/dialog-yesno/DialogYesNo.vue"
  import { downloadImageFile } from "@/views/loyalty/shared/modules/utilities"
  import { JustpayQrPaymentService } from "@/views/loyalty/shared/services/justpay-qrpayment-service"
  import { JustpayPointModel } from "@/views/loyalty/models/justpay-point.model"
  import { JustpayPaymentSystemService } from "@/views/loyalty/shared/services/justpay-paymentsystem-service"
  export default {
    components: { DialogYesNo, EventForm },
    props: ['create', 'change', 'view', 'show', 'item'],
    data: () => ({
      // monitoring_date: '',
      pair_code: '',
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
      selected: {
        type: null,
        equipment: null,
        current_equipment: null,
        change_settings: false
      },
      menu: {
        from: false,
        to: false
      },
      event: {
        items: [],
        form: {
          client: '',
          users: []
        },
      },
      token: { },
      info: { },
      loader: {
        show: false,
      },
      dialog: {
        event: {
          show: false,
          item: {},
        },
        user: {
          show: false,
          selected: []
        },
      },
      events: [],
      table: {
        headers: [
          {
            text: '',
            value: 'save',
          },
          {
            text: 'Название',
            value: 'name',
          },
          {
            text: 'Описание',
            value: 'comment',
          },
        ],
      },
      tabs: [
        'Основные',
        'Настройки',
        'Файлы',
      ],
      data: {
        phone: '',
      },
      monitoring:
          {
        items: [],
        total: 0,
        date: { from: format(new Date(), 'yyyy-MM-dd'), to: format(new Date(), 'yyyy-MM-dd') },
        menu: { from: false, to: false }
      },
      mdb:
          {
        items: [],
        total: 0,
        date: { from: format(new Date(), 'yyyy-MM-dd'), to: format(new Date(), 'yyyy-MM-dd') },
        menu: { from: false, to: false }
      },
      form: {
        email_type: 0,
        email_value: '',
        equipments: [
        ],
        users: [],
        sbp: {
          enable: false,
          bank: 0
        },
        cash: {
          enable: false,
        },
        digital_ruble: {
          enable: false,
        },
        bank_card: {
          enable: false,
        },
        qr_sticker: {
          enable: false,
        },
        qr_paymentsystem: {
          enable: false,
          // isRelay: false,
          qrStickerRelayType: 0,
        },
        tgbot: 0,
        local_fiscal: {
          enable: false,
          ipAddress: "",
          port: "",
        },
        wifi_hotspot: {
          network_name: "",
          password: "",
          security_key: "None",
          is_active: false
        },
        wifi_net: {
          network_name: "",
          password: "",
          security_key: "None",
          is_active: false,
          ip_address: '',
          mask: '',
          gateway: ''
        },
        ethernet: {
          is_active: false,
          ip_address: '',
          mask: '',
          gateway: ''
        },
        cellular_net: {
          is_active: true,
          cellular_generation: 1
        },
        kiosk_mode: true,
        access_by_staff_card: false,
        accessByCardStuff: { },
        verification: {
          profileId: null,
          verificationRequirement: 0
        }
      },
      logs: [],
      dict: {
        insurer: {},
        phone: {
          1: 'Мобильный',
          2: 'Домашний',
        },
        address: {
          1: 'Юридический адрес',
          2: 'Фактический адрес',
        },
        file: {
          type: {
            0: 'Без типа',
            1: 'Слайдер в описании проекта',
            2: 'Договор поручительства',
            3: 'Документы проекта',
          },
        },
        event: {
          1: 'Звонок',
          2: 'SMS сообщение',
          3: 'Email сообщение',
          4: 'Встреча',
          5: 'Другое',
        },
        device: {},
        type: {}
      },
      select: {
        taxation: [
          { value: 0, text: 'Общая СН' },
          { value: 1, text: 'Упрощенная СН (доходы);' },
          { value: 2, text: 'Упрощенная СН (доходы минус расходы)' },
          { value: 3, text: 'Единый налог на вмененный доход' },
          { value: 4, text: 'Единый сельскохозяйственный налог' },
          { value: 5, text: 'Патентная СН' }
        ],
        place: [],
        clients: [],
        profiles: [],
        type: [
        ],
        configurations: [],
        state: [
          { value: 0, text: 'Новый' },
          { value: 1, text: 'Активный' },
          { value: 2, text: 'Заблокирован' },
        ],
        device: [],
        equipment: [],
        point_type: [
          { value: 1, text: 'Торговая точка' },
          { value: 2, text: 'Вендинг' },
          { value: 3, text: 'Локальная платежная система' },
          { value: 4, text: 'Прием платежей' },
          { value: 5, text: 'Топливная система' },
          { value: 6, text: 'Транспортная система' }
        ],
        addressing_mode: [
          { value: 1, text: "Статический" },
          { value: 2, text: "Динамический" },
        ],
        cellular_generation: [
          { value: 1, text: "Auto" },
          { value: 2, text: "2G" },
          { value: 3, text: "3G" },
          { value: 4, text: "4G" },
        ]
      },
      suggestion: {
        address: false
      },
      search: {
        client: {
          loading: false,
          text: ''
        },
        equipment: {
          loading: false,
          text: ''
        },
      },
      ms: null, // MonitoringService,
      mps: null, // MonitoringPaginationService,
      adb_table_options: {},
      adb:
          {
        items: [],
        total: 0,
        date: { from: format(new Date(), 'yyyy-MM-dd'), to: format(new Date(), 'yyyy-MM-dd') },
        menu: { from: false, to: false }
      },
      mdb_table_options: {},
      monitoring_table_options: {},
      point: new JustpayPointModel(),
      pointId: null,
      pointTimeZone: 0,
      pointService: null,
      dialogVisible: false,
      toContinue: false,
      selectedEquipment: null,
      qrImage: null,
      qrPaymentSystemImage: null,
      justpayQrpaymentService: null,
      juspayPaymentSystemService: null,
      regUrl: '',
      dialogNoYes: {
        title: '',
        text: '',
        actionYes: null,
      },
    }),
    computed: {
      title: {
        get: function () {
          if (this.create) return 'Создание'
          if (this.change) return 'Изменение'
          if (this.view) return 'Просмотр'
          return ''
        },
      },
    },
    watch: {
      'search.client.text': function () {
        if (this.search.client.text) { this.load_clients(this.search.client.text) }
      },
      show: function () {
        if (this.show) {
          if (this.change) {
            this.form = JSON.parse(JSON.stringify(this.item))
          }

          if (this.view) {
            this.form = JSON.parse(JSON.stringify(this.item))
          }
          if (this.create) {
            this.form = {

            }
          }
        }
      },
      adb_table_options: {
        async handler () {
          console.log(this.table_options)
          const { sortBy, sortDesc, page, itemsPerPage } = this.adb_table_options
          const adb = await this.getAdb(page, itemsPerPage)
          console.log('watch adb', adb)
          this.adb.items = adb.adbLogs
          this.adb.total = adb.count
        },
        deep: true,
      },
      mdb_table_options: {
        async handler () {
          console.log(this.table_options)
          const { sortBy, sortDesc, page, itemsPerPage } = this.mdb_table_options
          const mdb = await this.getMdb(page, itemsPerPage)
          this.mdb.items = mdb.mdbLogs
          this.mdb.total = mdb.count
        },
        deep: true,
      },
      monitoring_table_options: {
        async handler () {
          console.log(this.table_options)
          const { sortBy, sortDesc, page, itemsPerPage } = this.monitoring_table_options
          const monitoring = await this.getMonitoring(page, itemsPerPage)
          this.monitoring.items = monitoring.monitorings
          this.monitoring.total = monitoring.count
        },
        deep: true,
      },
      // ms: {
      //   async handler (newValue, oldValue) {
      //           this.point = await this.ms.getLastRecordOfMonitoring({ pointId: this.pointId, timeZone: this.pointTimeZone })
      //               console.log('point', this.point)
      //   }
      // }
    },
    async beforeMount () {
      const pointId = this.$route.query.id
      this.justpayQrpaymentService = new JustpayQrPaymentService()
      this.justpayPaymentSystemService = new JustpayPaymentSystemService()
      if (pointId !== undefined) { this.qrImage = await this.justpayQrpaymentService.getQrcode(pointId) }
      if (pointId !== undefined) { this.qrPaymentSystemImage = await this.justpayPaymentSystemService.getQrcode(pointId) }
    },
    mounted: function () {
      if (this.create) {
        this.form.created = moment().format('YYYY-MM-DD')
      }
      // this.monitoring_date = moment().format('YYYY-MM-DD')
      for (const x in this.$store.state.dict.device_type) {
        this.dict.type[Number(x)] = this.$store.state.dict.device_type[x].name
      }
      for (const x in this.$store.state.dict.device_type) {
        this.select.type.push({
          value: Number(x),
          text: this.$store.state.dict.device_type[x].name
        })
      }
      var id = null
      if (this.item && this.item.id) id = this.item.id
      else
        if (this.$route.query.id && (this.view || this.change)) id = this.$route.query.id
        console.log('Point-form id=', id)
      if (id) {
        this.pointId = id
        this.load(id)
      }
      if (this.$store.state.user.current_client /* && !id */) {
        this.form.client = this.$store.state.user.current_client
        this.client_selected()
      }
      this.ms = new MonitoringService()
      this.mps = new MonitoringPaginationService()
      this.pointService = new JustpayPointService()
      console.log('this.adb', this.adb)
    },
    methods: {
      pair: function () {
        this.axios.post('/api/point/pair', {
          point: this.form.id
        })
          .then(result => {
            if (!result.data.error) {
              this.pair_code = result.data.data
            } else {
              this.$store.commit('snackbar', result.data.data || 'Ошибка при обновлении данных')
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', e || 'Ошибка при обновлении данных')
          })
      },
      load: function (id) {
        this.axios.post('/api/point/get', { id: id })
          .then(async result => {
            if (!result.data.error) {
              this.form = result.data.data
              this.form.users = this.form.users || []
              if (this.form.created) this.form.created = moment(this.form.created).format('YYYY-MM-DD')
              this.form.equipments = this.form.equipments || []
              this.form.sbp = this.form.sbp || {
                bank: 0
              }
              this.form.bank_card = this.form.bank_card || {}
              this.form.bank_card.paypro = this.form.bank_card.paypro || { login: '', password: '', view: 1 }
              this.form.cash = this.form.cash || {}
              this.form.digital_ruble = this.form.digital_ruble || {}
              this.form.qr_sticker = this.form.qr_sticker || {}
              this.form.qr_paymentsystem = this.form.qr_paymentsystem || {}
              this.form.local_fiscal = this.form.local_fiscal || { enable: false }
              this.form.wifi_hotspot = this.form.wifi_hotspot || { security_key: 'None' }
              this.form.wifi_net = this.form.wifi_net || { security_key: 'None' }
              this.form.ethernet = this.form.ethernet || { addressing_mode: 1 }
              this.form.cellular_net = this.form.cellular_net || { is_active: true, cellular_generation: 1 }
              this.form.verification = this.form.verification || { verificationRequirement: 0, profileId: null }
              this.form.accessByCardStuff = this.form.accessByCardStuff || { identityType: 0, ipAddress: "", port: 0 }
              console.log('this.form', this.form)

              this.select.clients = result.data.clients
              this.select.place = result.data.places
              for (const x in this.select.place) {
                this.select.place[x].name_full = this.select.place[x].name + '| ' + this.select.place[x].address
              }
              this.select.configurations = result.data.configurations
              this.select.device = result.data.devices
              this.select.equipment = result.data.equipments
              this.select.sbpprofile = result.data.sbpprofiles
              this.select.profiles = result.data.profiles
              this.pointTimeZone = result.data.data.timezone
              this.point = await this.ms.getLastRecordOfMonitoring({
                pointId: this.pointId,
                timeZone: this.pointTimeZone
              })
              // this.axios.post('/api/point/monitoring/get', { id: id, monitoring_date: this.monitoring_date })
              // .then(result => {
              //   if (!result.data.error) {
              //     this.monitoring = result.data.monitoring
              //     this.mdb = result.data.mdb
              //     this.adb = result.data.adb
              //   }
              // })
              // .catch(e => {
              //   console.log(e)
              // })
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      delete_user: function (item) {
        if (confirm('Вы уверены?')) {
            this.form.users = this.form.users.filter(a => a != item)
          }
      },
      add_users: function () {
        for (const x in this.dialog.user.selected) {
          const user = this.dialog.user.selected[x]
          if (!this.form.users.filter(a => a.id == user.id)[0]) {
            if (user.point && user.point !== this.pointId) {
              this.dialogVisible = true
              this.dialogNoYes.text = "Пользователь уже привязан к другой точке. Перепривязать?"
              this.dialogNoYes.actionYes = this.onAddUser.bind(this, user)
            } else { this.form.users.push(user) }
          }
        }
        this.form.users = this.form.users.filter(a => true)
        this.dialog.user.show = false
      },
      show_add_user_dialog: function () {
        this.dialog.user.selected = []
        this.dialog.user.show = true
      },
      equipment_selected: function () {
        this.token.serial = this.select.equipment.filter(a => a.id == this.token.equipment)[0].serial
      },
      generate_token: function () {
        this.token.point = this.form.id
        this.axios.post('/api/point/token', this.token)
          .then(result => {
            if (!result.data.error) {
              this.form = result.data.data
              if (this.form.created) this.form.created = moment(this.form.created).format('YYYY-MM-DD')
              this.form.equipments = this.form.equipments || []
              if (this.form.client) {
                this.load_clients_id(this.form.client)
              }
              // this.load_events()
              this.load_logs()
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      delete_equipment: function (item) {
        if (confirm('Подтвердите удаление устройства ' + this.dict.device[item.device] + ' ' + this.dict.type[item.type] + '\r\nПосле удаления текущие настройки устройства будут удалены')) {
          this.form.equipments = this.form.equipments.filter(a => a != item)
        }
      },
      change_equipment: function (item) {
        this.selected.current_equipment = item
        this.selected.change_settings = true
        console.log(this.selected.current_equipment)
      },
      client_selected: function () {
        this.axios.post('/api/equipment/list', {
          client: this.form.client,
          free: true
        })
        .then(result => {
            if (!result.data.error) {
              this.select.equipment = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
          })
        this.axios.post('/api/user/list', { client: this.form.client })
          .then(result => {
            if (!result.data.error) {
              this.select.user = []
              for (const x in result.data.data) {
                this.select.user.push({
                  value: result.data.data[x],
                  text: result.data.data[x].surname + ' ' + result.data.data[x].name + ' ' + result.data.data[x].patronymic
                })
              }
            }
          })
          .catch(e => {
            console.log(e)
          })
        this.axios.post('/api/place/list', {
          client: this.form.client, delete: false
        })
        .then(result => {
            if (!result.data.error) {
              this.select.place = result.data.data
              for (const x in this.select.place) {
                this.select.place[x].name_full = this.select.place[x].name + '| ' + this.select.place[x].address
              }
            }
          })
          .catch(e => {
            console.log(e)
          })
        //   this.axios.post('/api/configuration/list', {
        //     client: this.form.client, delete: false
        //   })
        // .then(result => {
        //     if (!result.data.error) {
        //       this.select.configurations = result.data.data
        //     }
        //   })
        //   .catch(e => {
        //     console.log(e)
        //   })
          this.axios.post('/api/sbpprofile/list', {
            client: this.form.client
          })
        .then(result => {
            if (!result.data.error) {
              this.select.sbpprofile = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
          })
      this.axios.post('/api/device/list', {
        client: this.form.client
      })
        .then(result => {
            if (!result.data.error) {
              this.select.device = result.data.data
              for (const x in result.data.data) {
                this.dict.device[result.data.data[x].id] = result.data.data[x].model
              }
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      client_filter: function (item, query, text) {
        if (item.legal && (item.legal.name.full).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.name.short).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.kpp).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.inn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.ogrn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      equipment_filter: function (item, query, text) {
        if (item.number) {
          if (item.number.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        }
        if (item.serial) {
          if (item.serial.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        }
        if (item.device && this.dict.device[item.device]) {
          if (item.device && this.dict.device[item.device].toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        }
        if (item.type && this.dict.type[item.type].toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      load_clients: function (text) {
        this.search.client.loading = true
        this.axios.post('/api/client/list', {
          search: text,
          limit: 10,
          delete: false
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
      load_clients_id: function (id) {
        if (!id) return
        this.axios.post('/api/client/list', {
          id: id
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
            this.client_selected()
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },

      settings_change: function (equipment, item) {
        console.log(equipment, item)
        if (item.new) {
          item.new = false
          equipment.settings.push({
            new: true,
            type: 0,
            values: []
          })
        }
      },
      get_color: function (item, type) {
        return 'white'
      },
      // load_events: function () {
      //   this.axios.post('/api/event/list', {
      //     point: this.form.id,
      //   })
      //     .then(result => {
      //       if (!result.data.error) {
      //         for (const x in result.data.data) {
      //           if (result.data.data[x].type > 0 && this.$store.state.dict.events[result.data.data[x].type]) result.data.data[x].color = this.$store.state.dict.events[result.data.data[x].type].color
      //           result.data.data[x].start = moment(result.data.data[x].date).format('DD.MM.YYYY') + ' ' + String(result.data.data[x].time).substring(0, 5)
      //           result.data.data[x].end = moment(result.data.data[x].date).format('YYYY-MM-DD') + ' ' + String(result.data.data[x].time).substring(0, 5)
      //           if (result.data.data[x].type > 0 && this.$store.state.dict.events[result.data.data[x].type]) result.data.data[x].name = this.$store.state.dict.events[result.data.data[x].type].name
      //         }
      //         this.events = result.data.data
      //       }
      //     })
      //     .catch(e => {
      //       console.log(e)
      //       this.$store.commit('snackbar', 'Ошибка при обновлении данных')
      //     })
      // },
      load_logs: function () {
        this.axios.post('/api/log/list', { entity: this.form.id, limit: 5 })
          .then(result => {
            if (!result.data.error) {
              this.logs = result.data.data || []
              for (const x in this.logs) {
                this.logs[x].date_text = moment(this.logs[x].date).format('DD.MM.YYYY HH:mm')
                this.logs[x].diff = (diff(JSON.parse(this.logs[x].old), (JSON.parse(this.logs[x].change))))
              }
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format_time: function (date) {
        return moment(date).format('DD.MM.YYYY HH:mm:ss')
      },
      format_contract: function (number, date) {
        return number + '/' + moment(date).format('DDMM')
      },
      showEvent: function (event) {
        this.dialog.event.data = event
        this.dialog.event.show = true
        this.dialog.event.create = false
        this.dialog.event.change = true
        this.dialog.event.view = false
      },
      showCreateEvent: function (event) {
        this.dialog.event.data = {
          point: this.form.id,
          point_item: this.form,
        }
        console.log(this.dialog.event.data)
        this.dialog.event.show = true
        this.dialog.event.create = true
        this.dialog.event.change = false
        this.dialog.event.view = false
      },
      getDoc: function (item) {
        console.log(item)
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file/get',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      open_file: function (id, item) {
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: id,
            name: 'id',
          })
        )
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item,
            name: 'name',
          })
        )
        form.appendTo('body').submit()
      },
      adress_input: function (item) {
        if (!this.suggestion.address) {
          console.log('[name=address]')
          this.suggestion.address = true
          $('[name=address]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              this.form.address = data.unrestricted_value
              this.form.address_data = data.data
            },
          })
        }
      },
      save_point: function (save) {
          let url = '/api/point/create'
          if (this.form.id) {
            url = '/api/point/save'
          }
          if (this.form.bank_card.bank !== 5 && this.form.bank_card.bank !== 6) {
            this.form.bank_card.billing_ip = ''
            this.form.bank_card.billing_port = 0
          }
          this.axios.post(url, this.form)
            .then(result => {
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Данные успешно сохранены')
                if (save) {
                  this.$router.go(-1)
                }
              } else {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
      },
      async getAdb (page = 1, limit = 10) {
        const adb = await this.mps.getAdb({ pointTimeZone: this.pointTimeZone, pointId: this.pointId, dateFrom: this.adb.date.from, dateTo: this.adb.date.to, page: page, limit: limit })
        console.log('adb', adb)
        return adb
      },
      async getMdb (page = 1, limit = 10) {
        const mdb = await this.mps.getMdb({ pointId: this.pointId, pointTimeZone: this.pointTimeZone, dateFrom: this.adb.date.from, dateTo: this.adb.date.to, page: page, limit: limit })
        console.log('mdb', mdb)
        return mdb
      },
      async getMonitoring (page = 1, limit = 10) {
        const monitoring = await this.mps.getMonitoring({ pointId: this.pointId, pointTimeZone: this.pointTimeZone, dateFrom: this.monitoring.date.from, dateTo: this.monitoring.date.to, page: page, limit: limit })
        console.log('monitoring', monitoring)
        return monitoring
      },
      async onAdbLog () {
        const adb = await this.getAdb()
          this.adb.items = adb.adbLogs
          this.adb.total = adb.count
      },
      async onMdbLog () {
        const mdb = await this.getMdb()
          this.mdb.items = mdb.mdbLogs
          this.mdb.total = mdb.count
      },
      async onMonitoring () {
        const mdb = await this.getMonitoring()
          this.monitoring.items = mdb.monitorings
          this.monitoring.total = mdb.count
      },
      onAddUser (addingUser) {
        this.form.users.push(addingUser)
        this.dialogVisible = false
      },
      onChangeTimezone () {
        if (this.form.timezone < 0) {
          this.form.timezone = 0
        }
      },
      onConfirm () {
        this.form.equipments.push(this.selected.equipment)
        this.selectedEquipment = null
        this.dialogVisible = false
      },
      async onCheckEquipment (selectedEquipment) {
        const equipment = await this.pointService.checkOwnedEquipment(selectedEquipment.id)
        if (equipment) {
        if (equipment.isOwned) {
          this.selectedEquipment = selectedEquipment
          this.dialogVisible = true
          this.dialogNoYes.text = "Оборудование уже используется! Продолжить?"
          this.dialogNoYes.actionYes = this.onConfirm
          } else {
          this.form.equipments.push(selectedEquipment)
          }
        }
      },
      onClipboard () {
        navigator.clipboard.writeText(this.regUrl)
      },
      onDownloadImage () {
        downloadImageFile('QrImage.jpg', this.qrImage.image)
      },
      onOpenConfiguration () {
          let role = 0
          console.log('form', this.form)
            console.log('view', this.view)
            console.log('this.$store.state', this.$store.state)
            if (this.$store.state.roles[1]) {
              role = 1
            } else {
              role = 2
            }
            console.log('role', this.$store.state.roles[2].role)
            let routeData
            if (this.view) {
                if (role === 1) { routeData = this.$router.resolve({ path: '/admin/configuration/view', query: { id: this.form.configuration } }) }
                if (role === 2) { routeData = this.$router.resolve({ path: '/client/configuration/view', query: { id: this.form.configuration } }) }
                window.open(routeData.href, '_blank')
            }
            if (this.change) {
                if (role === 1) { routeData = this.$router.resolve({ path: '/admin/configuration/change', query: { id: this.form.configuration } }) }
                if (role === 2) { routeData = this.$router.resolve({ path: '/client/configuration/change', query: { id: this.form.configuration } }) }
                window.open(routeData.href, '_blank')
            }
        },
        onOpenPlace () {
          let role = 0
            let routeData
          if (this.$store.state.roles[1]) {
            role = 1
          } else {
            role = 2
          }
            if (this.view) {
                if (role === 1) routeData = this.$router.resolve({ path: '/admin/place/view', query: { id: this.form.place } })
                if (role === 2) routeData = this.$router.resolve({ path: '/client/place/view', query: { id: this.form.place } })
                window.open(routeData.href, '_blank')
            }
            if (this.change) {
                if (role === 1) routeData = this.$router.resolve({ path: '/admin/place/change', query: { id: this.form.place } })
                if (role === 2) routeData = this.$router.resolve({ path: '/client/place/change', query: { id: this.form.place } })
                window.open(routeData.href, '_blank')
            }
        }
    },
  }
</script>
